__turbopack_context__.v({
  "chip": "FilterChip-module__McG8CW__chip",
  "count": "FilterChip-module__McG8CW__count",
  "lg": "FilterChip-module__McG8CW__lg",
  "md": "FilterChip-module__McG8CW__md",
  "minimal": "FilterChip-module__McG8CW__minimal",
  "pill": "FilterChip-module__McG8CW__pill",
  "rectangle": "FilterChip-module__McG8CW__rectangle",
  "sm": "FilterChip-module__McG8CW__sm",
  "underline": "FilterChip-module__McG8CW__underline",
});
